import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { and, isObjectControl, optionIs, rankWith } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { Localization, parseBase64Uri } from '@sphereon/ui-components.core';
import DragAndDropBox from '../../DragAndDropBox';
import PersonPlaceholder from '../../../assets/placeholders/PersonPlaceholder';
import FileSelection from '../../FileSelection';
import { base64UriToFile } from '../../../../utils';
import { PassportPhotoControlContainerStyled as Container, PassportPhotoControlDragAndDropBoxContainerStyled as DragAndDropBoxContainer, PassportPhotoControlPassportPhotoContainerStyled as PassportPhotoContainer, PassportPhotoControlPassportPhotoImageStyled as PassportPhotoImage, } from '../../../../styles';
import { FileSelectionFieldType } from '../../../../types';
const PassportPhotoControl = (props) => {
    const { data, handleChange, path } = props;
    const [image, setImage] = useState(data && { file: base64UriToFile(data.base64Uri, data.fileName, data.mimeType), base64Uri: data.base64Uri });
    const onAddImage = async (file) => {
        const reader = new FileReader();
        reader.onload = () => {
            const result = reader.result;
            if (typeof result === 'string') {
                const parsedBase64Uri = parseBase64Uri(result);
                setImage({ file, base64Uri: result });
                handleChange(path, { fileName: file.name, mimeType: parsedBase64Uri.mimeType, base64Uri: result });
            }
        };
        reader.readAsDataURL(file);
    };
    const onRemoveImage = async () => {
        setImage(undefined);
        handleChange(path, undefined);
    };
    return (_jsxs(Container, { children: [_jsxs(DragAndDropBoxContainer, { children: [_jsx(DragAndDropBox, { caption: Localization.translate('drag_and_drop_upload_image_caption'), description: Localization.translate('credential_attach_image_description'), onChangeFile: onAddImage }), _jsx(PassportPhotoContainer, { children: image ? _jsx(PassportPhotoImage, { src: image.base64Uri, alt: Localization.translate('passport_photo_alt') }) : _jsx(PersonPlaceholder, {}) })] }), image && _jsx(FileSelection, { file: image.file, fileType: FileSelectionFieldType.IMAGE, onRemove: onRemoveImage })] }));
};
export const passportPhotoControlTester = rankWith(3, and(isObjectControl, optionIs('type', 'passportPhoto')));
export default withJsonFormsControlProps(PassportPhotoControl);
